export const TIPOS_CON_RESTRINGIDOS_NUMERICOS = ["NORMAL", "REVENTADO", "MEGA"] as const;

export const SET_TIPOS_CON_RESTRINGIDOS_NUMERICOS = new Set<string>(TIPOS_CON_RESTRINGIDOS_NUMERICOS);
